(() => {
  const getVariantFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('variant');
  };

  const syncVariantSelectsFromUrl = () => {
    const variantId = getVariantFromUrl();
    if (!variantId) return;

    document.querySelectorAll('variant-selects[data-section]').forEach((variantSelectsEl) => {
      const variantDataScript = variantSelectsEl.querySelector('script[type="application/json"]');
      if (!variantDataScript) return;

      let variantData;
      try {
        variantData = JSON.parse(variantDataScript.textContent);
      } catch (error) {
        return;
      }

      const selectedVariant = variantData.find((variant) => String(variant.id) === String(variantId));
      if (!selectedVariant) return;

      const variantControls = variantSelectsEl.querySelectorAll('select, fieldset');
      variantControls.forEach((controlEl, index) => {
        const optionValue = selectedVariant.options[index];
        if (!optionValue) return;

        if (controlEl.tagName === 'SELECT') {
          controlEl.value = optionValue;
          return;
        }

        const inputEl = Array.from(controlEl.querySelectorAll('input')).find((input) => input.value === optionValue);
        if (inputEl) inputEl.checked = true;
      });

      variantSelectsEl.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const init = () => {
    syncVariantSelectsFromUrl();
    // Re-run once in case third-party scripts mutate selectors after initial render.
    window.setTimeout(syncVariantSelectsFromUrl, 350);
  };

  const start = () => {
    if (!window.customElements || !window.customElements.whenDefined) {
      init();
      return;
    }

    window.customElements.whenDefined('variant-selects').then(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
